<template>
  <div id="layout-wrapper">
    <!-- partial:partials/_navbar.html -->
    <navbarTop v-if="currentRouteName != 'Login'"></navbarTop>
    <!-- partial -->

    <div class="main-content" v-if="currentRouteName != 'Login'" :style="(currentRouteName == 'day_off_create' || currentRouteName == 'day_off_edit' ? 'min-height : 800px' : '')">
      <div class="page-content">
        <!-- content-wrapper -->
        <router-view />
        <!-- content-wrapper ends -->
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">2020 © Chevycare</div>
            <div class="col-sm-6">
              <div class="text-sm-right d-none d-sm-block"></div>
            </div>
          </div>
        </div>
      </footer>
    </div>

    <!-- page-body-wrapper ends -->
    <div v-if="currentRouteName == 'Login'">
      <router-view />
    </div>
  </div>
</template>

<script>
import navbarTop from "@/components/layouts/navbar_top";

export default {
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  components: {
    navbarTop,
  },
};
</script>
